import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  fr: {
    // Navbar
    nav_dashboard: "Tableau de bord",
    nav_fiches: "Fiches",
    nav_hymne: "Hymne",
    nav_exam: "Examen blanc",
    nav_admin: "Admin",
    nav_premium: "Premium",
    nav_login: "Connexion",
    nav_logout: "Déconnexion",
    nav_donate: "Faire un don",
    nav_admin_panel: "Administration",

    // Landing
    landing_title: "Préparez votre test civique français",
    landing_subtitle: "134 questions officielles, fiches de révision et examens blancs pour réussir votre entretien de naturalisation.",
    landing_cta: "Commencer gratuitement",
    landing_cta_signup: "Créer mon compte gratuit",
    landing_ready: "Prêt à commencer votre préparation ?",
    landing_ready_sub: "Rejoignez des milliers de candidats qui préparent leur test de naturalisation.",
    landing_footer_support: "Soutenir le projet",
    landing_stat_questions: "Questions officielles",
    landing_stat_fiches: "Fiches de révision",
    landing_stat_categories: "Catégories",
    landing_stat_exams: "Examens blancs",
    landing_feature1_title: "Questions officielles",
    landing_feature1_desc: "134 questions extraites du programme officiel de l'entretien civique.",
    landing_feature2_title: "Fiches de révision",
    landing_feature2_desc: "30 fiches synthétiques basées sur le Livret du Citoyen.",
    landing_feature3_title: "Examens blancs",
    landing_feature3_desc: "Simulez l'entretien avec des examens chronométrés en conditions réelles.",

    // Auth
    auth_register: "Inscription",
    auth_login: "Connexion",
    auth_name: "Nom complet",
    auth_email: "Email",
    auth_password: "Mot de passe",
    auth_confirm_password: "Confirmer le mot de passe",
    auth_create_account: "Créer mon compte",
    auth_sign_in: "Se connecter",
    auth_creating: "Création...",
    auth_signing_in: "Connexion...",
    auth_forgot_password: "Mot de passe oublié ?",
    auth_back_home: "Retour à l'accueil",
    auth_fill_all: "Veuillez remplir tous les champs",
    auth_password_mismatch: "Les mots de passe ne correspondent pas",
    auth_password_min: "Le mot de passe doit contenir au moins 6 caractères",
    auth_success_register: "Compte créé avec succès !",
    auth_success_login: "Connexion réussie !",

    // Dashboard
    dash_hello: "Bonjour",
    dash_continue: "Continuez votre préparation au test civique français.",
    dash_quizzes_done: "Quiz complétés",
    dash_success_rate: "Taux de réussite",
    dash_correct: "Bonnes réponses",
    dash_questions_tried: "Questions tentées",
    dash_categories: "Catégories de quiz",
    dash_progress: "Progression",
    dash_recent: "Activité récente",
    dash_no_activity: "Aucune activité pour le moment",
    dash_quick: "Accès rapide",
    dash_fiches_btn: "Fiches de révision",
    dash_exam_btn: "Examen blanc",
    dash_donate_btn: "Faire un don",
    dash_tip_title: "Conseil du jour",
    dash_tip: "Révisez régulièrement les fiches sur les valeurs de la République. C'est un thème central du test civique.",
    dash_admin_title: "Espace Administrateur",
    dash_admin_desc: "Gérer les utilisateurs, voir les donations et statistiques",
    dash_admin_btn: "Accéder",
    dash_install_title: "Installer CiviquePrep",
    dash_install_desc: "Accédez rapidement depuis votre écran d'accueil",
    dash_install_btn: "Installer",

    // Quiz
    quiz_question: "Question",
    quiz_of: "sur",
    quiz_next: "Suivante",
    quiz_finish: "Terminer",
    quiz_result: "Résultat",
    quiz_score: "Score",
    quiz_time: "Temps",
    quiz_correct: "Correct",
    quiz_wrong: "Incorrect",
    quiz_retry: "Recommencer",
    quiz_back: "Retour",
    quiz_explanation: "Explication",

    // Fiches
    fiches_title: "Fiches de révision",
    fiches_subtitle: "Révisez les thèmes clés du Livret du Citoyen",
    fiches_key_points: "Points clés",
    fiches_back: "Retour aux fiches",

    // Exam
    exam_title: "Examen blanc",
    exam_subtitle: "Simulez l'entretien civique en conditions réelles",
    exam_start: "Commencer l'examen",
    exam_time_limit: "Temps limité",
    exam_questions: "questions",
    exam_minutes: "minutes",

    // Hymne
    hymne_title: "La Marseillaise",
    hymne_subtitle: "Hymne national de la République française",
    hymne_play: "Écouter l'hymne",
    hymne_pause: "Pause",
    hymne_lyrics: "Paroles",
    hymne_history: "Histoire",
    hymne_remember: "À retenir pour l'examen civique",

    // Donation
    donate_title: "Soutenez CiviquePrep",
    donate_subtitle: "CiviquePrep est gratuit. Votre don aide à maintenir la plateforme et à la rendre accessible à tous.",
    donate_custom: "Montant libre :",
    donate_btn: "Faire un don",
    donate_pay_card: "Payer par carte",
    donate_card: "Carte bancaire",
    donate_secure: "Paiement sécurisé par",
    donate_secure_end: ". Aucune donnée bancaire n'est stockée sur nos serveurs.",
    donate_thanks: "Merci pour votre don !",
    donate_thanks_sub: "Votre générosité contribue à maintenir CiviquePrep gratuit et accessible à tous.",
    donate_donors: "donateurs",
    donate_raised: "récoltés",
    donate_select: "Choisissez un montant pour voir le bouton PayPal",

    // Premium
    premium_title: "Passez à Premium",
    premium_subtitle: "Débloquez toutes les fonctionnalités et maximisez vos chances de réussite au test civique.",
    premium_trial: "Essai gratuit de 7 jours",
    premium_trial_sub: "Testez toutes les fonctionnalités Premium sans engagement",
    premium_trial_btn: "Essayer gratuitement",
    premium_free: "Gratuit",
    premium_popular: "POPULAIRE",
    premium_monthly: "Mensuel",
    premium_lifetime: "À vie",
    premium_per_month: "/mois",
    premium_or: "ou",
    premium_buy_monthly: "Mensuel — 4.99€",
    premium_buy_lifetime: "À vie — 9.99€",
    premium_guarantee: "Paiement sécurisé. Satisfait ou remboursé sous 14 jours.",
    premium_already: "Vous êtes Premium !",
    premium_activating: "Activation de votre abonnement Premium...",

    // Forgot Password
    forgot_title: "Mot de passe oublié",
    forgot_subtitle: "Saisissez votre email pour réinitialiser votre mot de passe",
    forgot_verify: "Vérifier mon email",
    forgot_verifying: "Vérification...",
    forgot_new_title: "Nouveau mot de passe",
    forgot_new_subtitle: "Choisissez un nouveau mot de passe pour votre compte",
    forgot_new_password: "Nouveau mot de passe",
    forgot_confirm: "Confirmer le mot de passe",
    forgot_reset: "Réinitialiser mon mot de passe",
    forgot_resetting: "Réinitialisation...",
    forgot_done_title: "Mot de passe modifié",
    forgot_done_sub: "Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter.",
    forgot_back_login: "Retour à la connexion",

    // Common
    back: "Retour",
    loading: "Chargement...",
    error: "Erreur",
    cancel: "Annuler",
    save: "Enregistrer",
    delete: "Supprimer",
    confirm: "Confirmer",
    close: "Fermer",
    back_dashboard: "Retour au tableau de bord",
  },

  en: {
    // Navbar
    nav_dashboard: "Dashboard",
    nav_fiches: "Study Cards",
    nav_hymne: "Anthem",
    nav_exam: "Mock Exam",
    nav_admin: "Admin",
    nav_premium: "Premium",
    nav_login: "Sign In",
    nav_logout: "Sign Out",
    nav_donate: "Donate",
    nav_admin_panel: "Administration",

    // Landing
    landing_title: "Prepare for your French Civic Test",
    landing_subtitle: "134 official questions, study cards and mock exams to pass your naturalization interview.",
    landing_cta: "Get Started for Free",
    landing_cta_signup: "Create my free account",
    landing_ready: "Ready to start your preparation?",
    landing_ready_sub: "Join thousands of candidates preparing for their naturalization test.",
    landing_footer_support: "Support this project",
    landing_stat_questions: "Official Questions",
    landing_stat_fiches: "Study Cards",
    landing_stat_categories: "Categories",
    landing_stat_exams: "Mock Exams",
    landing_feature1_title: "Official Questions",
    landing_feature1_desc: "134 questions from the official civic interview program.",
    landing_feature2_title: "Study Cards",
    landing_feature2_desc: "30 summary cards based on the Citizen's Handbook.",
    landing_feature3_title: "Mock Exams",
    landing_feature3_desc: "Simulate the interview with timed exams under real conditions.",

    // Auth
    auth_register: "Register",
    auth_login: "Sign In",
    auth_name: "Full Name",
    auth_email: "Email",
    auth_password: "Password",
    auth_confirm_password: "Confirm Password",
    auth_create_account: "Create my account",
    auth_sign_in: "Sign In",
    auth_creating: "Creating...",
    auth_signing_in: "Signing in...",
    auth_forgot_password: "Forgot password?",
    auth_back_home: "Back to home",
    auth_fill_all: "Please fill in all fields",
    auth_password_mismatch: "Passwords do not match",
    auth_password_min: "Password must be at least 6 characters",
    auth_success_register: "Account created successfully!",
    auth_success_login: "Login successful!",

    // Dashboard
    dash_hello: "Hello",
    dash_continue: "Continue your French civic test preparation.",
    dash_quizzes_done: "Quizzes completed",
    dash_success_rate: "Success rate",
    dash_correct: "Correct answers",
    dash_questions_tried: "Questions attempted",
    dash_categories: "Quiz Categories",
    dash_progress: "Progress",
    dash_recent: "Recent Activity",
    dash_no_activity: "No activity yet",
    dash_quick: "Quick Access",
    dash_fiches_btn: "Study Cards",
    dash_exam_btn: "Mock Exam",
    dash_donate_btn: "Donate",
    dash_tip_title: "Tip of the day",
    dash_tip: "Review the cards about Republic values regularly. It's a core topic of the civic test.",
    dash_admin_title: "Admin Panel",
    dash_admin_desc: "Manage users, view donations and statistics",
    dash_admin_btn: "Access",
    dash_install_title: "Install CiviquePrep",
    dash_install_desc: "Quick access from your home screen",
    dash_install_btn: "Install",

    // Quiz
    quiz_question: "Question",
    quiz_of: "of",
    quiz_next: "Next",
    quiz_finish: "Finish",
    quiz_result: "Result",
    quiz_score: "Score",
    quiz_time: "Time",
    quiz_correct: "Correct",
    quiz_wrong: "Incorrect",
    quiz_retry: "Try Again",
    quiz_back: "Back",
    quiz_explanation: "Explanation",

    // Fiches
    fiches_title: "Study Cards",
    fiches_subtitle: "Review key topics from the Citizen's Handbook",
    fiches_key_points: "Key Points",
    fiches_back: "Back to cards",

    // Exam
    exam_title: "Mock Exam",
    exam_subtitle: "Simulate the civic interview under real conditions",
    exam_start: "Start Exam",
    exam_time_limit: "Time limited",
    exam_questions: "questions",
    exam_minutes: "minutes",

    // Hymne
    hymne_title: "La Marseillaise",
    hymne_subtitle: "National Anthem of the French Republic",
    hymne_play: "Listen to the anthem",
    hymne_pause: "Pause",
    hymne_lyrics: "Lyrics",
    hymne_history: "History",
    hymne_remember: "Remember for the civic exam",

    // Donation
    donate_title: "Support CiviquePrep",
    donate_subtitle: "CiviquePrep is free. Your donation helps maintain the platform and make it accessible to everyone.",
    donate_custom: "Custom amount:",
    donate_btn: "Donate",
    donate_pay_card: "Pay by card",
    donate_card: "Credit Card",
    donate_secure: "Secure payment by",
    donate_secure_end: ". No banking data is stored on our servers.",
    donate_thanks: "Thank you for your donation!",
    donate_thanks_sub: "Your generosity helps keep CiviquePrep free and accessible to everyone.",
    donate_donors: "donors",
    donate_raised: "raised",
    donate_select: "Choose an amount to see the PayPal button",

    // Premium
    premium_title: "Go Premium",
    premium_subtitle: "Unlock all features and maximize your chances of passing the civic test.",
    premium_trial: "7-day free trial",
    premium_trial_sub: "Try all Premium features with no commitment",
    premium_trial_btn: "Try for free",
    premium_free: "Free",
    premium_popular: "POPULAR",
    premium_monthly: "Monthly",
    premium_lifetime: "Lifetime",
    premium_per_month: "/month",
    premium_or: "or",
    premium_buy_monthly: "Monthly — €4.99",
    premium_buy_lifetime: "Lifetime — €9.99",
    premium_guarantee: "Secure payment. 14-day money-back guarantee.",
    premium_already: "You are Premium!",
    premium_activating: "Activating your Premium subscription...",

    // Forgot Password
    forgot_title: "Forgot Password",
    forgot_subtitle: "Enter your email to reset your password",
    forgot_verify: "Verify my email",
    forgot_verifying: "Verifying...",
    forgot_new_title: "New Password",
    forgot_new_subtitle: "Choose a new password for your account",
    forgot_new_password: "New password",
    forgot_confirm: "Confirm password",
    forgot_reset: "Reset my password",
    forgot_resetting: "Resetting...",
    forgot_done_title: "Password Changed",
    forgot_done_sub: "Your password has been reset successfully. You can now sign in.",
    forgot_back_login: "Back to sign in",

    // Common
    back: "Back",
    loading: "Loading...",
    error: "Error",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    confirm: "Confirm",
    close: "Close",
    back_dashboard: "Back to dashboard",
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "fr");

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations.fr[key] || key;
  const toggleLang = () => setLang((prev) => (prev === "fr" ? "en" : "fr"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider");
  return context;
};
